import UploadableLayout from '../components/layouts/UploadableLayout.vue';
import UploadableIndexPage from '../pages/UploadableIndexPage.vue';

/**
 * @type {import('vue-router').RouteRecordRaw[]}
 */
export default [
    {
        // This is the parent route for your package.
        // It uses the layout component.
        path: '/uploadable',
        name: 'uploadable.root',
        component: UploadableLayout,
        meta: {
            // e.g., requiresAuth: true
            // requiresAuth: true,
            // title: 'uploadable.nav.title',
            // layout: 'Authenticated',
        },
        // All other package routes are children of this layout
        children: [
            {
                // Child path is empty, so it renders at /uploadable
                path: '',
                name: 'UploadableIndexPage',
                component: UploadableIndexPage,
            },
            // --- Example of other child routes ---
            // {
            //   path: 'create', // Renders at /uploadable/create
            //   name: 'uploadable.create',
            //   component: () => import('../components/Create.vue'),
            // },
        ]
    }
];
